import React from 'react';


const Error = ({ error }) => (
  <div className="row">
    <div align="center">
      <div className="has-error">
        <label className="help-block">
          {error}
        </label>
      </div>
      <br />
    </div>
  </div>
);

export default Error;


// WEBPACK FOOTER //
// ./app/javascript/components/subscription_plan/components/UI/Error.js